'use strict';

function createTripTypeUtils(searchTypes) {
    const resultsTripTypes = ['ONE_WAY', 'ROUND_TRIP', 'MULTIPLE_DESTINATIONS', 'MULTI_SEGMENT'];
    const resultsTripTypesEnum = Odigeo._.zipObject(resultsTripTypes, searchTypes);

    const searchAcronymTypes = ['OW', 'RT', 'MD', 'MS'];
    const searchTinyAcronymTypes = ['O', 'R', 'M', 'S'];
    const oneWayOrRoundTripTypes = Odigeo._.take(searchTypes, 2);
    const tripTypeToAcronymMap = Odigeo._.zipObject(searchTypes, searchAcronymTypes);
    const tripTypeToTinyAcronymMap = Odigeo._.zipObject(searchTypes, searchTinyAcronymTypes);
    const tripTypeToResultsTypeMap = Odigeo._.zipObject(searchTypes, resultsTripTypes);

    return {
        toResultsType: function(type) {
            return tripTypeToResultsTypeMap[type];
        },
        toAcronym: function(type) {
            return tripTypeToAcronymMap[type];
        },
        toTinyAcronym: function(type) {
            return tripTypeToTinyAcronymMap[type];
        },
        isRoundTrip: function(type) {
            return type === resultsTripTypesEnum.ROUND_TRIP;
        },
        isOneWay: function(type) {
            return type === resultsTripTypesEnum.ONE_WAY;
        },
        isMultipleDestinations: function(type) {
            return type === resultsTripTypesEnum.MULTIPLE_DESTINATIONS;
        },
        isMultiSegment: function(type) {
            return type === resultsTripTypesEnum.MULTI_SEGMENT;
        },
        isMultiFlightType: function(type) {
            return this.isMultipleDestinations(type) || this.isMultiSegment(type);
        },
        isOneWayOrRoundTrip: function(type) {
            return Odigeo._.includes(oneWayOrRoundTripTypes, type);
        },
        ofResults: function() {
            return createTripTypeUtils(resultsTripTypes);
        },
        fromResults: function(resultTripType) {
            return searchTypes[Odigeo._.indexOf(resultsTripTypes, resultTripType)];
        },
    };
}

module.exports = createTripTypeUtils(['oneWayTrip', 'roundTrip', 'multipleTrip', 'multiSegment']);
